
import React from 'react';
import { Route } from 'react-router';
import { Admin, Resource } from 'react-admin';
import registerIcon from '@material-ui/icons/Home';
import profilesIcon from '@material-ui/icons/School';
import profilesSearchIcon from '@material-ui/icons/Search';
import schoolsIcon from '@material-ui/icons/AccountBalance';


import { reducer as tree } from 'ra-tree-ui-materialui';

import { ProfilesList, ProfilesEdit, ProfilesCreate } from './views_profiles';

import { SchoolsList, SchoolsEdit, SchoolsCreate } from './views_schools';

import { ProfilesSearchList, AdminProfileShow } from './views_profiles_search';

import { RegisterCreate, RegisterList, RegisterList2, UserProfileEdit, ChangePasswordEdit,
        ResendRegistrationVerification, RequestPasswordReset, ResetPassword } from './views_register';

//import tarpIcon from '@material-ui/icons/Book';
//import { TarpList, TarpCreate } from './views_tarp';
import authClient from './pkadmin/authClient';
import Login from './pkadmin/login'
import restClient from './pkadmin/restClient'

import i18nProvider from './pkadmin/i18nProvider';
import CustomRouteLayout from './pkadmin/customRouteLayout';
import CustomRouteNoLayout from './pkadmin/customRouteNoLayout';
import Menu from './menu';
import MyLayout from './Layout';

const App = (props) => {
  console.log("App.props", props)
  return (
    <Admin
      somerandomvar={true}
        appLayout={MyLayout}
        menu={Menu}
        authProvider={authClient}
        dataProvider={restClient()}
        i18nProvider={i18nProvider}
        title="Example Admin"
        locale="en"
        customReducers={{ tree }}
        loginPage={Login}
        customRoutes={[
            <Route
                exact
                path="/custom"
                component={CustomRouteNoLayout}
                noLayout
            />,
            <Route exact path="/custom2" component={CustomRouteLayout} />,
            <Route exact path="/loginAfterRegistration"
                render={(props) => <Login {...props} previousRegistration={true} />}
                />
        ]}
        >
{permissions => {console.log("permissions=",permissions); return [
        permissions === 'admin' ? [
          <Resource create={SchoolsCreate} edit={SchoolsEdit} icon={schoolsIcon} list={SchoolsList} name="schools" options={{ label: 'School Profile' }} />,
          <Resource name="admin_profiles" icon={profilesSearchIcon} list={ProfilesSearchList} options={{label: 'Search' }} show={AdminProfileShow} />,
          <Resource name="user_profile" icon={profilesSearchIcon} edit={UserProfileEdit} options={{label: 'Search' }} />,
          <Resource name="password_change" edit={ChangePasswordEdit}  />
        ] :
        permissions === 'teacher' ? [
          <Resource create={ProfilesCreate} edit={ProfilesEdit} icon={profilesIcon} list={ProfilesList} name="profiles" options={{ label: 'Profiles' }} />,
          <Resource name="user_profile" icon={profilesSearchIcon} edit={UserProfileEdit} />,
          <Resource name="password_change" edit={ChangePasswordEdit}  />,
        ] :
        [
          <Resource edit={RegisterCreate} list={RegisterList} icon={registerIcon} name="register" options={{ label: 'Home' }} />,
          <Resource name="resend_registration" edit={ResendRegistrationVerification} />,
          <Resource create={RequestPasswordReset} name="request_password_reset"  list={RegisterList2} options={{ noMenuItem: true }} />,
          <Resource create={ResetPassword} name="reset_password"  list={RegisterList2} options={{ noMenuItem: true }} />
        ]
]}}
    </Admin>
)
}

//<Resource create={TarpCreate} icon={tarpIcon} list={TarpList} name="tarp" options={{ label: 'Tarp' }} />
export default App;
